// extracted by mini-css-extract-plugin
module.exports = {"sustentabilidad":"sustentabilidad_sustentabilidad__3BHs_","cuadros":"sustentabilidad_cuadros__2tNL3","video":"sustentabilidad_video__1SWmg"};